import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { hotelStatusesEditable, hotelStatusNames } from 'main/hotelStatuses'
import { useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'

const EditStatusDialog = ({ onClose, onSave, status }) => {
  const [newStatus, setNewStatus] = useState(status)
  const [reason, setReason] = useState('')

  function updateStatus() {
    subsidiariesApi
      .updateStatus({ reason, status: newStatus })
      .then(() => {
        onSave()
      })
      .catch(() => {
        onSave()
      })
  }

  return (
    <ConfirmationDialog
      positiveMessage="Save"
      negativeMessage="Cancel"
      title="Change hotel status"
      onClose={onClose}
      onConfirm={updateStatus}
      isButtonDisabled={!reason}
    >
      {hotelStatusesEditable.includes(status) ? (
        <Dropdown
          value={newStatus}
          isSortedAlphabetically={false}
          onChange={e => setNewStatus(e.target.value)}
          options={hotelStatusesEditable.reduce(
            (prev, curr) => ({ ...prev, [curr]: hotelStatusNames[curr] }),
            {}
          )}
        />
      ) : (
        <Dropdown
          value={newStatus}
          onChange={e => setNewStatus(e.target.value)}
          options={{
            Churned: 'Churned',
            Paused: 'Paused',
            [status]: hotelStatusNames[status]
          }}
        />
      )}
      <div>
        <TextInput
          label="Status change reason (mandatory)"
          value={reason}
          style={{ width: 340 }}
          onChange={e => setReason(e.target.value)}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default EditStatusDialog
